var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "640" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("vat-overrides.title"))),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _c("p", { staticClass: "hint" }, [
            _vm._v(" " + _vm._s(_vm.$ct("vat-overrides.hint")) + " "),
          ]),
          _vm._l(_vm.rows, function (o, i) {
            return _c(
              "w-row",
              { key: i },
              [
                _c(
                  "w-col",
                  { attrs: { xs: "12", md: "4" } },
                  [
                    _c("w-select", {
                      attrs: {
                        fancy: "",
                        label: _vm.$ct("vat-overrides.regime"),
                        items: _vm.regimeItems,
                      },
                      model: {
                        value: o.regime,
                        callback: function ($$v) {
                          _vm.$set(o, "regime", $$v)
                        },
                        expression: "o.regime",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "w-col",
                  { attrs: { xs: "5", md: "3" } },
                  [
                    _c("w-input", {
                      attrs: {
                        fancy: "",
                        type: "number",
                        label: _vm.$ct("vat-overrides.rate"),
                      },
                      model: {
                        value: o.rate,
                        callback: function ($$v) {
                          _vm.$set(o, "rate", $$v)
                        },
                        expression: "o.rate",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "w-col",
                  { attrs: { xs: "5", md: "4" } },
                  [
                    _c("w-select", {
                      attrs: {
                        fancy: "",
                        label: _vm.$ct("vat-overrides.code"),
                        items: _vm.vatCodeItems,
                      },
                      model: {
                        value: o.code,
                        callback: function ($$v) {
                          _vm.$set(o, "code", $$v)
                        },
                        expression: "o.code",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "w-col",
                  { staticClass: "row-remove", attrs: { xs: "2", md: "1" } },
                  [
                    _c(
                      "w-link",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.rows.splice(i, 1)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-link",
            {
              staticClass: "add-link",
              on: {
                click: function ($event) {
                  return _vm.addRow()
                },
              },
            },
            [
              _c("w-fa", { attrs: { icon: "plus" } }),
              _vm._v(" " + _vm._s(_vm.$ct("vat-overrides.add")) + " "),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.apply()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("vat-overrides.apply")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }